<template>
  <div>
    <div class="itinerary row">
      <div>{{itienary.originCity}}</div>
      <i class="itinerary-icon icon-flight-1"></i>
      <div>{{itienary.destinationCity}}</div>
    </div>
    <div class="itinerary row">
      <div>تاریخ پرواز :</div>
      <div class="title-value">{{itienary.departureDateTime}}</div>
    </div>
    <div class="itinerary row">
      <div>تعداد مسافر :</div>
      <div class="title-value">{{itienary.adultQty+itienary.infantQty+itienary.childQty}}</div>
    </div>
    <hr />
    <a class="btn_full_outline" href="invoice.html" target="_blank">تغییر جستجو</a>
  </div>
</template>

<script>
export default {
  name: "pdk-Flight-Itinerary",
  props: { itienary: {} },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style>
.itinerary-icon {
  transform: rotate(180deg);
  padding-left: 6px;
  padding-right: 6px;
}
.itinerary {
  margin-top: 10px;
  font-size: 16px;
  margin-left: auto;
  margin-right: auto;
}

.title-value {
  color: #008489;
  margin-right: 5px;
}
</style>


